import sourceDebugger from './source-debugger'
import oauth from './oauth'
import application from './application'

export default {
  application,
  oauth,
  sourceDebugger
}
